import React, { useState, useEffect } from 'react';
import { getProductosCatalogo } from '../../services/productosApi';
import { obtenerCategoriasTPV } from '../../services/categoriasServicio';
import { Item } from '../Tienda/Catalogo/Item';
import Buscador from '../Tienda/Catalogo/Buscador';
import CarritoLateral from '../Tienda/Carrito/CarritoLateral';
import ThemeInjector from '../Tienda/ThemeInjector';
import PaymentModalTPV from '../Tienda/Checkout/PaymentModalTPV';
import { registrarPedidoTPV, obtenerUrlCierreDespacho } from '../../services/pedidosServicio';
import ModalCapturaCliente from '../Tienda/Checkout/ModalCapturaCliente';
// import { useLicencia } from '../../hooks/useLicencia';
// import PantallaBloqueo from '../PantallaBloqueo';
import { ejecutarImpresionTPV } from '../../services/Impresion';
import { getDatosNegocio } from '../../services/NegocioServicio';
import { obtenerSectores, obtenerMetodosPagoPersonalizados } from '../../services/ConfiguracionServicio';
import { obtenerDisponibilidad } from '../../services/configTiendaApi';
import config from '../../config/apiConfig';
import usePedidosKDS from '../Tienda/usePedidosKDS';
import imgDefault from '../../imgs/defecto.png';
import { useJsApiLoader } from '@react-google-maps/api';
import config_, { resolveImagenUrl } from '../../config/appConfig';
import { fetchConfiguracion, fetchConfiguracionParametros, getAjustesParametrosCache } from '../../services/ConfiguracionServicio';
import { usePlan } from '../context/PlanContext';
import MenuCategorias from '../menu/MenuCategorias';
import SelectorVariantesModal from '../Generales/SelectorVariantes';


import { toast, ToastContainer } from 'react-toastify';
const getVariantesTexto = (item) => {
    if (!item) return "";
    if (item.variantes_detalles) return item.variantes_detalles;
    if (item.variantes) return item.variantes;
    if (Array.isArray(item.mods)) return item.mods.map(m => (typeof m === 'object' ? (m.nombre || m.name) : m)).join(', ');
    if (Array.isArray(item.opciones_escogidas)) return item.opciones_escogidas.map(o => o.nombre || o.nombre_opcion).join(', ');
    return "";
};
// 🚩 'drawing' se sacó: Google eliminó DrawingManager de la API (removido may-2026).
const libraries = ['places', 'geometry'];

function TPV() {

    const { tieneMesas } = usePlan();
    const [modalPropinaAbierto, setModalPropinaAbierto] = useState(false);
    const [propinaSeleccionada, setPropinaSeleccionada] = useState(0);
    const [pedidoEnProcesoCobro, setPedidoEnProcesoCobro] = useState(null);
    const [modalCorreccionAbierto, setModalCorreccionAbierto] = useState(false);
    const [pedidoACorregir, setPedidoACorregir] = useState(null);
    const [mesasConPedido, setMesasConPedido] = useState([]);
    const [cargandoMesas, setCargandoMesas] = useState(false);
    // 🚩 Reemplaza window.prompt() para el motivo: los navegadores bloquean
    // silenciosamente los prompt() nativos despues de uso repetido (checkbox
    // "Impedir que esta pagina cree mas cuadros de dialogo"), devolviendo null
    // sin avisar. Eso hacia que CORREGIR MESA pareciera "no hacer nada".
    const [modalMotivoAbierto, setModalMotivoAbierto] = useState(false);
    const [motivoTexto, setMotivoTexto] = useState('');
    const [correccionPendiente, setCorreccionPendiente] = useState(null); // { itemEditado, nuevaCantidad }

    const handleCorregirItemMesa = (itemEditado, nuevaCantidad) => {
        setCorreccionPendiente({ itemEditado, nuevaCantidad });
        setMotivoTexto('');
        setModalMotivoAbierto(true);
    };

    const confirmarCorreccionItemMesa = async () => {
        const motivo = motivoTexto.trim();
        if (!motivo) {
            toast.error("El motivo es obligatorio");
            return;
        }
        const { itemEditado, nuevaCantidad } = correccionPendiente;

        // 🚩 ASEGÚRATE QUE ESTO TRAIGA EL ID DEL PEDIDO, NO DE LA MESA
        const pedidoId = pedidoACorregir.pedido_id;

        // 1. Calcular nuevos items localmente
        const nuevosItems = pedidoACorregir.items.map(i => {
            if (String(i.id) === String(itemEditado.id)) return { ...i, cantidad: nuevaCantidad };
            return i;
        }).filter(i => i.cantidad > 0);

        const nuevoTotal = nuevosItems.reduce((acc, i) => acc + (Number(i.precio) * Number(i.cantidad)), 0);

        try {
            const token = localStorage.getItem("token");
            const baseUrl = config.api_url.replace(/\/$/, "");

            const res = await fetch(`${baseUrl}/api/v1/pedidos/corregir-item`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'token': token },
                body: JSON.stringify({
                    pedido_id: pedidoId,
                    items: nuevosItems,
                    nuevo_total: nuevoTotal,
                    motivo: motivo
                })
            });

            const resData = await res.json();

            if (res.ok && resData.status === 'success') {
                toast.success("Mesa actualizada");

                // Actualizar el estado local para que la UI cambie de inmediato
                setPedidoACorregir({
                    ...pedidoACorregir,
                    items: nuevosItems,
                    total: nuevoTotal
                });

                // Recargar monitor y mesas
                obtenerMesasActivas();
                fetchPedidosWeb();

                setModalMotivoAbierto(false);
                setCorreccionPendiente(null);
                setMotivoTexto('');
            } else {
                toast.error("Error en el server: " + resData.message);
            }
        } catch (e) {
            toast.error("Error de conexión");
        }
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: config_.google_api,
        libraries: libraries
    });
    const [finalOrder, setFinalOrder] = useState({ cartItems: [], total: 0, id_actualizar: null });
    const [productosBase, setProductosBase] = useState([]);
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [carro, setCarro] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [tipoZonas, setTipoZonas] = useState('geocerca');
    const [metodosPagoPersonalizados, setMetodosPagoPersonalizados] = useState([]);
    const [tipoVenta, setTipoVenta] = useState('USUARIO_PRESENCIAL');
    const [modalPagoAbierto, setModalPagoAbierto] = useState(false);
    const [modalClienteAbierto, setModalClienteAbierto] = useState(false);
    const [modalPesoAbierto, setModalPesoAbierto] = useState(false);
    const [itemParaPesar, setItemParaPesar] = useState(null);
    const [valorIngresado, setValorIngresado] = useState('');

    const [modalDetalleAbierto, setModalDetalleAbierto] = useState(false);
    const [pedidoParaVer, setPedidoParaVer] = useState(null);

    const [modalSelectorEntrega, setModalSelectorEntrega] = useState(false);
    const [mostrarCarro, setMostrarCarro] = useState(false);
    const [itemParaPersonalizar, setItemParaPersonalizar] = useState(null);
    const [editandoItemId, setEditandoItemId] = useState(null); // 🚩 Para saber si estamos editando un item del carro
    const [categoriaActual, setCategoriaActual] = useState(null);
    const [catHorizontal, setCatHorizontal] = useState(() => localStorage.getItem('tpv_cat_layout') === 'horizontal');
    const toggleCatLayout = () => {
        const next = !catHorizontal;
        setCatHorizontal(next);
        localStorage.setItem('tpv_cat_layout', next ? 'horizontal' : 'vertical');
    };
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [configNegocio, setConfigNegocio] = useState(null);
    const [ultimaVenta, setUltimaVenta] = useState(() => {
        // Intentamos cargar la última venta del almacenamiento local por si refrescan la página
        const guardada = localStorage.getItem('ultima_venta_tpv');
        return guardada ? JSON.parse(guardada) : null;
    });
    const [ajustesImpresion, setAjustesImpresion] = useState(() => getAjustesParametrosCache() || {});

    // 🚩 CERRAR_DELIVERY_PAGADO (definido en vtgx_config_parametros_def).
    // Con el parametro activo, un delivery que YA quedo pagado se cierra al
    // tiro en vez de quedar esperando en el panel de la izquierda: hay locales
    // que no llevan control de reparto y no quieren el flujo de dos pasos.
    // Los retiros y los pedidos sin pagar nunca se cierran solos, porque ahi
    // siempre queda algo por cobrar o por entregar al cliente.
    // El valor puede llegar como 1, true o '1' segun de donde venga.
    const cerrarDeliveryPagado = [1, true, '1'].includes(ajustesImpresion.CERRAR_DELIVERY_PAGADO);

    // Para decidir un cobro se pide la configuración fresca al servidor. El
    // cache local sirve para pintar la pantalla al abrir, pero no para decidir
    // si un delivery se cobra o queda pendiente: un flag viejo descuadraría caja.
    const asegurarAjustesActuales = async () => {
        try {
            const res = await fetchConfiguracionParametros({ permitirCache: false });
            const ajustes = (res && res.ajustes) || {};
            if (Object.keys(ajustes).length > 0) setAjustesImpresion(ajustes);
            return ajustes;
        } catch (e) {
            console.error("No se pudo asegurar la configuración antes del cobro:", e);
            return {};
        }
    };

    // 🚩 Un pedido es de mesa solo si su origen lo dice. Antes se usaba
    // `estado_id === 7` como atajo, y un retiro en "Por cobrar" se abría como
    // si fuera una mesa ("Mesa: 27"), aplicándole propina de mesa.
    const esPedidoMesa = (pedido) => {
        if (!pedido) return false;
        const origen = String(pedido.origen || pedido.plataforma_origen || '').toUpperCase();
        return origen.includes('MESA') || Boolean(pedido.mesa_nombre) || Boolean(pedido.mesa_id);
    };

    const etiquetaPedidoCobro = (pedido) => {
        if (!pedido) return 'Pedido';
        if (pedido.origen_tpv) return 'Venta TPV';

        if (esPedidoMesa(pedido)) {
            const mesa = pedido.mesa_nombre || pedido.cliente_nombre || pedido.display_id || '';
            return mesa ? `Mesa ${String(mesa).replace(/^Mesa\s*/i, '')}` : 'Mesa';
        }

        const folio = pedido.display_id || pedido.id || '';
        return folio ? `Pedido #${folio}` : 'Pedido';
    };
    // sección descuentos
    const [modalDescuentoAbierto, setModalDescuentoAbierto] = useState(false);
    const [descuentoGlobal, setDescuentoGlobal] = useState(0); // 0 a 100 (%)
    const [valorDescuentoInput, setValorDescuentoInput] = useState('');
    const [modalDecisionRetiro, setModalDecisionRetiro] = useState(false);
    const [mostrarExito, setMostrarExito] = useState(false);
    // 🚩 Modo carrito: fijo en desktop, flotante en móvil
    const [modoCarrito, setModoCarrito] = useState('fijo');
    // 🚩 Detectar si es móvil para UI adaptativa
    const [esMobile, setEsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const checkMobile = () => {
            const isMobile = window.innerWidth < 768;
            setEsMobile(isMobile);
            setModoCarrito(isMobile ? 'flotante' : 'fijo');
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const cargarConfiguracionCompleta = async () => {
            try {
                // 1. Cargamos ajustes generales y parámetros de una vez
                const [resAjustes, resParams, datosNegocio] = await Promise.all([
                    fetchConfiguracion(),
                    fetchConfiguracionParametros(), // 🚩 Traemos los parámetros de impresión aquí
                    getDatosNegocio()
                ]);

                // 2. Guardamos los parámetros de impresión en nuestro nuevo estado
                setAjustesImpresion(resParams.ajustes || {});

                // 3. Lo demás sigue igual...
                const perfil = Array.isArray(datosNegocio) ? datosNegocio[0] : datosNegocio;
                const valoresAjustes = resAjustes.ajustes || resAjustes;
                setConfigNegocio({ ...perfil, ...valoresAjustes });

            } catch (error) {
                console.error("Error al cargar configuración:", error);
            }
        };
        cargarConfiguracionCompleta();
    }, []);

    const [mostrarPedidosWeb, setMostrarPedidosWeb] = useState(false);
    const { orders: pedidosWeb, fetchOrders: fetchPedidosWeb } = usePedidosKDS();

    const [ahora, setAhora] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setAhora(new Date()), 30000);
        return () => clearInterval(timer);
    }, []);

    const dispararExitoVenta = () => {
        // 1. Sonido
        const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2013/2013-preview.mp3');
        audio.volume = 0.5;
        audio.play().catch(e => console.log("Audio bloqueado"));

        // 2. Visual
        setMostrarExito(true);
        setTimeout(() => setMostrarExito(false), 3000); // Se quita en 3 segundos
    };

    const obtenerMesasActivas = async () => {
        setCargandoMesas(true);
        try {
            const token = localStorage.getItem("token");
            const baseUrl = config.api_url.replace(/\/$/, "");

            // 🚩 Este endpoint debe devolver el JOIN de vtgx_mesas y vtgx_pedidos
            const res = await fetch(`${baseUrl}/api/v1/pedidos/mesas/activas`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'token': token }
            });
            const data = await res.json();

            // Si el backend envía los items como string, los parseamos
            const procesados = (data.data || data).map(m => ({
                ...m,
                items: typeof m.items_json === 'string' ? JSON.parse(m.items_json) : (m.items_json || [])
            }));

            setMesasConPedido(procesados);
        } catch (e) {
            toast.error("Error al cargar mesas");
        } finally {
            setCargandoMesas(false);
        }
    };


    const obtenerUrlImagen = (producto) => {
        // 1. Extraer el nombre o ruta del objeto
        const path = producto.url_imagen || producto.img || producto.imagen;

        // 2. Si no existe la imagen, devolver el chef por defecto (imgDefault)
        if (!path || path === "null" || path === "" || path === undefined) {
            return imgDefault;
        }

        // 3. Limpieza de seguridad: si el path empieza con "/", se lo quitamos para no duplicar la barra
        const pathLimpio = path.startsWith('/') ? path.substring(1) : path;

        // 4. resolveImagenUrl deja pasar URLs http absolutas y arma la URL de R2 para el resto
        return resolveImagenUrl(pathLimpio);
    };
    const retomarPedido = (order) => {
        // Leemos flags desde los parámetros del sistema (Ajustes del Sistema)
        const porcPropina = Number(ajustesImpresion && ajustesImpresion.PORCENTAJE_PROPINA || 0);
        const propinaMesas = ajustesImpresion && ajustesImpresion.PROPINA_MESAS === true;
        const propinaTpv = ajustesImpresion && ajustesImpresion.PROPINA_TPV === true;

        const esMesa = esPedidoMesa(order);

        // Si es mesa Y PROPINA_MESAS activado, calculamos con el % real
        if (esMesa && propinaMesas && porcPropina > 0) {
            // La cuenta pudo quedar con propina sumada desde la precuenta
            // (estado 7). Se descuenta para no cobrarla dos veces.
            const propinaGuardada = Number(order.propina || 0);
            const baseTotal = Math.max(0, Number(order.total) - propinaGuardada);
            const subtotal = Math.max(0, baseTotal - Number(order.costo_envio || 0) + Number(order.descuento_valor || 0));
            setPedidoEnProcesoCobro({ ...order, total: baseTotal });
            setPropinaSeleccionada(Math.round(subtotal * (porcPropina / 100)));
            setModalPropinaAbierto(true);
        } else {
            setPropinaSeleccionada(0);
            setFinalOrder({ ...order, id_actualizar: order.id, total: Number(order.total) });
            setModalPagoAbierto(true);
        }
    };

    const retomarPedido_ = (p) => {
        const esMesa = esPedidoMesa(p);

        if (esMesa) {
            // 🚩 Si es mesa, calculamos la sugerida pero abrimos el modal de ajuste
            const propinaGuardada = Number(p.propina || 0);
            const baseTotal = Math.max(0, Number(p.total) - propinaGuardada);
            const subtotal = Math.max(0, baseTotal - Number(p.costo_envio || 0) + Number(p.descuento_valor || 0));
            const sugerida = Math.round(subtotal * 0.10);

            setPropinaSeleccionada(sugerida);
            setPedidoEnProcesoCobro({ ...p, total: baseTotal });
            setModalPropinaAbierto(true);
        } else {
            // Si es delivery/retiro, pasa directo a la caja como siempre
            setPropinaSeleccionada(0);
            setFinalOrder({ ...p, id_actualizar: p.id });
            setModalPagoAbierto(true);
        }
    };


    // funcion teclas...
    // --- SHORTSCUTS DE CONTROL ---
    useEffect(() => {
        const handleKeyDown = (event) => {
            // 1. F9: Abrir selector de despacho
            if (event.key === 'F9') {
                event.preventDefault();
                if (carro.length > 0) setModalSelectorEntrega(true);
            }

            // 2. F10: Pagar / Confirmar
            if (event.key === 'F10') {
                event.preventDefault();
                if (carro.length > 0) {
                    const total = carro.reduce((acc, item) => acc + (Number(item.precio) * Number(item.cantidad)), 0);
                    confirmarCompra(total);
                }
            }

            // 3. F1 y F2: Selección dentro del modal (Solo si está abierto)
            if (event.key === 'F1' && modalSelectorEntrega) {
                event.preventDefault();
                seleccionarRetiro();
            }
            if (event.key === 'F2' && modalSelectorEntrega) {
                event.preventDefault();
                seleccionarDelivery();
            }

            // 4. ESCAPE: Cerrar todo
            if (event.key === 'Escape') {
                event.preventDefault();
                setModalSelectorEntrega(false);
                setModalPagoAbierto(false);
                setModalClienteAbierto(false);
                setMostrarCarro(false);
                setItemParaPersonalizar(null);
                setMostrarPedidosWeb(false);
                // No dejar la terminal en modo RETIRO/DELIVERY tras cancelar.
                setTipoVenta('USUARIO_PRESENCIAL');
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [carro, modalSelectorEntrega, tipoVenta]); // <--- Estas dependencias hacen que la función siempre sepa la verdad

    const calcularTranscurrido = (order) => {
        const fechaStr = order.created_at || order.time || order.fecha;
        if (!fechaStr) return { texto: "0 min", atrasado: false };

        let d = new Date(fechaStr);
        if (isNaN(d.getTime())) {
            d = new Date(String(fechaStr).replace(' ', 'T'));
        }
        if (isNaN(d.getTime())) return { texto: "0 min", atrasado: false };

        const difMin = Math.floor((ahora.getTime() - d.getTime()) / 60000);
        const atrasado = difMin >= 30;

        if (difMin <= 0) return { texto: "Recién", atrasado };
        if (difMin < 60) return { texto: `${difMin} min`, atrasado };
        return { texto: `${Math.floor(difMin / 60)}h ${difMin % 60}m`, atrasado };
    };



    const handleImprimirYPreparar = async (e, p) => {
        e.stopPropagation();

        // 1. Datos mínimos para la comanda física
        const d = {
            id: p.id,
            display_id: p.display_id,
            nombre_cliente: p.customer ? (p.customer.name || p.customer.nombre) : (p.cliente_nombre || 'VENTA WEB'),
            observacion: p.observacion || '',
            cartItems: p.items.map(i => ({
                cantidad: i.cantidad,
                nombre: i.nombre,
                variantes: getVariantesTexto(i),
                categoria: (i.categoria_nombre || i.categoria || "VARIOS").toUpperCase(),
                descripcion: i.descripcion || "", // <--- ¡AGREGA ESTO AQUÍ!
            })),
        };


        // 2. Ejecuta la impresión de comanda (Cocina)
        ejecutarImpresionTPV(d, 'SOLO_COMANDA', ajustesImpresion);

        // 🚩 Si el pedido web es delivery, ademas del comanda sale el ticket
        // de DESPACHO con la direccion. La comanda de arriba no sirve para
        // eso: es para cocina y va sin datos de entrega.
        const tipoWeb = String(p.type || p.tipo_entrega_nombre || '').toUpperCase();
        const esDeliveryWeb = Number(p.tipo_entrega_id) === 2 || tipoWeb.includes('DELIVERY');

        if (esDeliveryWeb) {
            const dDespacho = {
                ...d,
                direccion: p.customer ? (p.customer.address || p.customer.direccion || '') : '',
                telefono_cliente: p.customer ? (p.customer.phone || p.customer.telefono || '') : '',
                metodo_pago: p.metodo_pago || '',
                pagado: p.pagado,
                costo_envio: p.costo_envio || 0,
                // El total viene calculado del backend; el formateador usa
                // subtotal + envio, asi que se le pasa el subtotal ya neto.
                subtotal: Number(p.total || 0) - Number(p.costo_envio || 0),
                cartItems: p.items.map(i => ({
                    cantidad: i.cantidad,
                    nombre: i.nombre,
                    precio: i.precio || i.valor || 0,
                    variantes: getVariantesTexto(i),
                })),
            };
            // 🚩 QR de cierre: se pide la URL firmada al backend ANTES de
            // imprimir. Si falla (o el servicio no tiene internet en ese
            // instante), el ticket sale igual, solo que sin el bloque QR.
            try {
                const urlCierre = await obtenerUrlCierreDespacho(p.id);
                if (urlCierre && urlCierre.res && urlCierre.url_cierre) {
                    dDespacho.url_cierre = urlCierre.url_cierre;
                }
            } catch (errUrl) {
                console.error('No se pudo obtener la url de cierre:', errUrl);
            }
            setTimeout(() => {
                ejecutarImpresionTPV(dDespacho, 'SOLO_DESPACHO', ajustesImpresion);
            }, 1200);
        }


        // 3. Cambia el estado en el servidor (De 'Recibida' a 'Preparando')
        // Esto refresca tu lista lateral automáticamente sin crear pedidos duplicados.
        await cambiarEstadoWeb(p.id, 'Preparando');
    };


    const verDetallePedido = (e, p) => {
        setPedidoParaVer(p);
        setModalDetalleAbierto(true);
    };




    useEffect(() => {
        let filtrados = Array.isArray(productosBase) ? [...productosBase] : [];

        // --- LA MAGIA DE ORDENAMIENTO EN EL FRONT ---
        if (categoriaActual === null) {
            // CASO 1: Estamos en "Todos" -> Ordenar por los más vendidos (descendente)
            filtrados.sort((a, b) => (b.cantidad_vendida || 0) - (a.cantidad_vendida || 0));
        } else {
            // CASO 2: Ahora filtramos por UUID para que sea a prueba de errores de carga masiva
            filtrados = filtrados.filter(p => Number(p.categoria_id) === Number(categoriaActual));
            filtrados.sort((a, b) => (a.orden_visual || 999) - (b.orden_visual || 999));
        }

        // --- BUSCADOR (Se aplica sobre lo que ya está ordenado) ---
        if (terminoBusqueda) {
            const termino = terminoBusqueda.toLowerCase();
            filtrados = filtrados.filter(p =>
                (p.nombre || '').toLowerCase().includes(termino) ||
                String(p.codigo_barras || '').toLowerCase().includes(termino)
            );
        }

        setProductosFiltrados(filtrados);
    }, [categoriaActual, terminoBusqueda, productosBase]);

    useEffect(() => {
        // 1. Carga categorías
        obtenerCategoriasTPV().then(setCategorias).catch(console.error);

        // 2. Carga productos
        getProductosCatalogo(2).then(d => {
            setProductosBase(Array.isArray(d) ? d : (d.productos || []));
        }).catch(console.error);

        // 3. Carga sectores
        const fetchData = async () => {
            try {
                const sectoresData = await obtenerSectores();
                const rawSectores = Array.isArray(sectoresData) ? sectoresData : (sectoresData && sectoresData.data ? sectoresData.data : []);
                const procesados = rawSectores.map(s => ({
                    ...s,
                    poligono: typeof s.poligono === 'string' ? JSON.parse(s.poligono) : s.poligono
                }));
                setSectores(procesados);
            } catch (e) { console.error("Error cargando sectores:", e); }
        };
        fetchData();

        // 3b. Carga el enfoque de zonas (geocerca o nombre) configurado por el negocio
        obtenerDisponibilidad().then(d => {
            if (d && d.tipoZonas) setTipoZonas(d.tipoZonas);
        }).catch(e => console.error("Error cargando tipoZonas:", e));

        // 3c. Carga métodos de pago personalizados (botón "Otros" en el cobro)
        obtenerMetodosPagoPersonalizados().then(data => {
            setMetodosPagoPersonalizados(Array.isArray(data) ? data : []);
        }).catch(e => console.error("Error cargando métodos de pago personalizados:", e));

        // 4. Cargar pedidos web al montar
        if (fetchPedidosWeb) fetchPedidosWeb();
    }, []); // eslint-disable-line

    const cambiarEstadoWeb = async (pedidoId, statusName) => {
        try {
            const STATUS_TO_ID = { 'Recibida': 1, 'Preparando': 2, 'Lista': 3, 'EnReparto': 4, 'Entregada': 5 };
            const token = localStorage.getItem("token");
            const res = await fetch(config.api_url.replace(/\/$/, "") + "/api/v1/pedidos/" + pedidoId + "/cambiar_estado", {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'token': token },
                body: JSON.stringify({ nuevoEstadoId: STATUS_TO_ID[statusName] })
            });
            if (res.ok) fetchPedidosWeb();
        } catch (err) { console.error("Error al cambiar estado", err); }
    };

    const handleDespachar = async (e, p) => {
        e.stopPropagation();

        const estaPagado = Number(p.pagado) === 1 || Number(p.payment_status) === 1;
        const idEntrega = Number(p.tipo_entrega_id || p.id_tipo_entrega);
        const tipoTexto = String(p.type || p.tipo || '').toUpperCase();
        const esDelivery = (idEntrega === 3 || tipoTexto.includes('DELIVERY'));
        const nombreDelCliente = p.customer ? (p.customer.name || p.customer.nombre || p.cliente_nombre) : (p.cliente_nombre || "Cliente");
        const direccionDelCliente = p.customer ? (p.customer.address || p.customer.direccion || p.direccion) : (p.direccion || "");
        const valorEnvio = Number(p.costo_envio || p.costo_delivery || 0);
        const valorSubtotal = Number(p.total) - valorEnvio;

        const datosParaRecibo = {
            ...p,
            nombre_cliente: nombreDelCliente,
            direccion: direccionDelCliente,
            observacion: p.observacion || "",
            subtotal: valorSubtotal,
            costo_envio: valorEnvio,
            total: Number(p.total),
            cartItems: Array.isArray(p.items) ? p.items.map(i => ({
                ...i,
                cantidad: i.cantidad,
                nombre: i.nombre,
                precio: i.precio,
                variantes: getVariantesTexto(i)
            })) : []
        };

        if (!esDelivery) {
            if (estaPagado) await cambiarEstadoWeb(p.id, 'Entregada');
            else { setMostrarPedidosWeb(false); retomarPedido(p); }
        } else {
            if (p.status === 'EnReparto') {
                if (estaPagado) await cambiarEstadoWeb(p.id, 'Entregada');
                else { setMostrarPedidosWeb(false); retomarPedido(p); }
            } else {
                // 🚩 Validar flag IMPRIMIR_RECIBO antes de imprimir recibo de despacho
                const imprimirReciboTPV = ajustesImpresion && ajustesImpresion.IMPRIMIR_RECIBO !== false;
                if (imprimirReciboTPV) {
                    ejecutarImpresionTPV(datosParaRecibo, 'SOLO_RECIBO', ajustesImpresion);
                }
                await cambiarEstadoWeb(p.id, 'EnReparto');
            }
        }
    };


    const agregarAlCarro = (p) => {
        if (p.venta_por_peso) {
            setItemParaPesar(p);
            setValorIngresado('');
            setModalPesoAbierto(true);
            return;
        }

        // 🚩 REGLA DE ORO: Si tiene variantes, NO lo metas al carro, ABRE EL MODAL
        // 🚩 VALIDACIÓN REAL: grupos/variantes deben tener opciones, no basta con que existan
        const gruposConOpciones = p.grupos && p.grupos.length > 0 && p.grupos.some(g => g && g.opciones && Array.isArray(g.opciones) && g.opciones.length > 0);
        const variantesConOpciones = p.variantes && p.variantes.length > 0 && p.variantes.some(g => g && g.opciones && Array.isArray(g.opciones) && g.opciones.length > 0);
        const tieneV = gruposConOpciones || variantesConOpciones;

        if (tieneV) {
            handlePersonalizarItem(p); // Esto abre el modal con precio base
            return;
        }

        // Si no tiene variantes (Bebida), entra directo
        setCarro(prev => {
            const ex = prev.find(i => String(i.id) === String(p.id) && !i.variantes_detalles);
            return ex
                ? prev.map(i => String(i.id) === String(p.id) ? { ...i, cantidad: i.cantidad + 1 } : i)
                : [...prev, { ...p, cantidad: 1 }];
        });
        // 🚩 Solo abrir carrito flotante si estamos en modo flotante
        if (modoCarrito === 'flotante') setMostrarCarro(true);
    };

    const agregarAlCarro_ = (p) => {
        if (p.venta_por_peso) {
            setItemParaPesar(p);
            setValorIngresado('');
            setModalPesoAbierto(true);
            return;
        }
        setCarro(prev => {
            const ex = prev.find(i => i.id === p.id && !i.variantes_detalles);
            // 👇 AGREGAMOS p.uuid AQUÍ
            return ex
                ? prev.map(i => i.id === p.id ? { ...i, cantidad: i.cantidad + 1 } : i)
                : [...prev, { ...p, cantidad: 1 }]; // Solo el objeto producto con su ID
        });
        setMostrarCarro(true);
    };

    const confirmarProductoPesado = () => {
        if (!itemParaPesar || !valorIngresado || parseFloat(valorIngresado) <= 0) return;
        const montoTotalDeseado = parseFloat(valorIngresado);
        const precioUnitarioBase = parseFloat(itemParaPesar.precio || itemParaPesar.valor || 0);

        if (precioUnitarioBase <= 0) { alert("Error: El producto no tiene precio base."); return; }

        const pesoCalculado = montoTotalDeseado / precioUnitarioBase;
        const itemFinal = {
            ...itemParaPesar,
            producto_id: itemParaPesar.id, // <--- GUARDAMOS EL ID NUMÉRICO REAL AQUÍ
            id: `granel_${itemParaPesar.id}_${Date.now()}`, // Esto se queda para que React no falle
            precio: precioUnitarioBase,
            cantidad: pesoCalculado,
            variantes_detalles: `Peso: ${pesoCalculado.toFixed(3)} Kg`

        };

        setCarro([...carro, itemFinal]);
        setModalPesoAbierto(false);
        setMostrarCarro(true);
        setValorIngresado('');
    };


    const confirmarCompra = (totalConDescuento) => {
        if (carro.length === 0) return;

        const porcPropina = Number(ajustesImpresion && ajustesImpresion.PORCENTAJE_PROPINA || 0);
        const propinaTpv = ajustesImpresion && ajustesImpresion.PROPINA_TPV === true;

        // 🚩 PROPINA_TPV: Si está activo y no es pedido telefónico, abrir modal de propina antes de la caja
        if (propinaTpv && porcPropina > 0 && tipoVenta.indexOf('TELEFONO') === -1) {
            setPropinaSeleccionada(Math.round(totalConDescuento * (porcPropina / 100)));
            setPedidoEnProcesoCobro({ total: totalConDescuento, cartItems: carro, origen_tpv: true });
            setModalPropinaAbierto(true);
            setMostrarCarro(false);
            return;
        }

        // Ahora finalOrder recibe el total que ya viene con el descuento aplicado
        setPropinaSeleccionada(0);
        setFinalOrder({
            id_actualizar: null,
            cartItems: carro,
            propina: 0,
            total: totalConDescuento
        });

        if (tipoVenta.indexOf('TELEFONO') !== -1) setModalSelectorEntrega(true);
        else setModalPagoAbierto(true);
        setMostrarCarro(false);
    };
    const confirmarCompra_ = (t) => {
        if (carro.length === 0) return;
        setFinalOrder({ id_actualizar: null, cartItems: carro, total: t });
        if (tipoVenta.indexOf('TELEFONO') !== -1) setModalSelectorEntrega(true);
        else setModalPagoAbierto(true);
        setMostrarCarro(false);
    };

    const handlePersonalizarItem = (item) => {
        if (!item) return;
        setMostrarCarro(false);

        // 🚩 DETECTAMOS SI VIENE DEL CARRO (tiene opciones_escogidas)
        const vieneDelCarro = item.opciones_escogidas && item.opciones_escogidas.length > 0;
        if (vieneDelCarro) {
            setEditandoItemId(item.id);
        } else {
            setEditandoItemId(null);
        }

        // 🚩 Buscamos el producto original del catálogo para tener los grupos/variantes completos
        const idReal = String(item.id).split('_')[0];
        const productoCatalogo = productosBase.find(p => String(p.id) === idReal);

        // Si encontramos el producto en el catálogo, usamos sus grupos (que tienen toda la info)
        if (productoCatalogo && productoCatalogo.grupos) {
            setItemParaPersonalizar({
                ...productoCatalogo,
                opciones_escogidas: item.opciones_escogidas || [],
                precio: item.precio // Preservamos el precio personalizado si viene del carro
            });
        } else {
            setItemParaPersonalizar(item);
        }
    };

    const handlePaymentSuccessTPV = async (datosVenta) => {
        const token = localStorage.getItem("token");

        // 🚩 DETECTAMOS SI ES DELIVERY
        const esDelivery = tipoVenta && tipoVenta.includes('DELIVERY');

        // --- CASO A: ACTUALIZAR PAGO DE PEDIDO YA EXISTENTE ---
        const idExistente = finalOrder.id_actualizar || (finalOrder && finalOrder.id);

        if (idExistente) {
            try {
                const baseUrl = config.api_url.replace(/\/$/, "");
                const urlCobro = `${baseUrl}/api/v1/pedidos/${idExistente}/confirmar_pago`;

                const resPago = await fetch(urlCobro, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'token': token },
                    body: JSON.stringify({
                        metodo_pago: datosVenta.metodo_pago,
                        pagado: 1,

                        propina: propinaSeleccionada, // La que confirmamos en el modal
                        // 🔥 ARREGLO 1: Usar el total que viene del Modal (con descuento)
                        // 🚩 Aseguramos que el total final sea el que tiene el descuento
                        total_final: datosVenta.total,

                        // 🚩 Mandamos el descuento con los nombres más comunes de tu BD
                        monto_descuento: datosVenta.monto_descuento || 0,
                        descuento_valor: datosVenta.monto_descuento || 0

                    })
                });

                if (resPago.ok) {
                    // 🚩 Validar flag IMPRIMIR_RECIBO antes de imprimir
                    const imprimirReciboTPV = ajustesImpresion && ajustesImpresion.IMPRIMIR_RECIBO !== false;
                    if (!esDelivery && imprimirReciboTPV) {
                        // 🔥 CORREGIDO: Pasamos propina explícitamente para que se imprima en el recibo
                        ejecutarImpresionTPV({
                            ...finalOrder,
                            ...datosVenta,
                            propina: propinaSeleccionada,
                            metodo_pago: datosVenta.metodo_pago,
                            total: Number(finalOrder.total || 0),
                            subtotal: Number(finalOrder.total || 0) - Number(propinaSeleccionada || 0)
                        }, 'SOLO_RECIBO', ajustesImpresion);
                    }
                    await cambiarEstadoWeb(idExistente, 'Entregada');
                    setModalPagoAbierto(false);
                    setPropinaSeleccionada(0);
                    setFinalOrder({ cartItems: [], total: 0, id_actualizar: null });
                    if (fetchPedidosWeb) fetchPedidosWeb();
                } else {
                    alert("Error en el servidor al cobrar.");
                }
            } catch (e) {
                alert("Error de red al cobrar.");
            }
            return;
        }

        // --- CASO B: VENTA NUEVA (MOSTRADOR, RETIRO O DELIVERY) ---
        try {
            const info = datosVenta.cliente || finalOrder.cliente || {};
            const itemsParaGuardar = datosVenta.items_calculados ? datosVenta.items_calculados : carro;

            // 1. Sacamos el valor de la COMIDA (con o sin descuento).
            // Fallback: si el flujo no manda total (retiro/delivery pendiente),
            // se calcula desde los items para no guardar un pedido en $0.
            const totalCarrito = (itemsParaGuardar || []).reduce(
                (acc, it) => acc + (Number(it.precio || it.valor || 0) * Number(it.cantidad || 1)), 0
            );
            const valorComida = datosVenta.total !== undefined
                ? datosVenta.total
                : (Number(finalOrder.total || 0) > 0 ? Number(finalOrder.total) : totalCarrito);

            // 2. Sacamos el valor del ENVÍO
            const costoDelEnvio = Number(info.costoEnvio || info.valor_entrega || 0);

            // 🚩 3. LA SUMA SAGRADA: Total Final = Comida + Envío
            const totalFinal = Number(valorComida) + costoDelEnvio;

            const ahorro = datosVenta.monto_descuento || 0;
            const lugarConsumoFinal = datosVenta.lugar_consumo || finalOrder.lugar_consumo || info.lugar_consumo || 'LLEVAR';

                const comandaData = {
                cartItems: itemsParaGuardar,
                total: totalFinal, // <--- Ahora sí dirá 7.200
                subtotal: totalFinal + ahorro - costoDelEnvio, // Esto da los 3.700 originales
                metodo_pago: datosVenta.metodo_pago,
                nombre_cliente: info.nombreCliente || info.nombre || info.cliente || "Venta TPV",
                telefono_cliente: info.telefono || info.telefonoCliente || info.tel || "",
                direccion: info.direccionEnvio || info.direccion || "",
                tipo_venta: datosVenta.tipo_venta || tipoVenta,
                id_tipo_entrega: esDelivery ? 2 : 1,
                sector_id: info.sectorId || info.id_sector || null,
                pagado: datosVenta.metodo_pago === 'PENDIENTE_PAGO' ? 0 : 1,
                // El backend vuelve a exigir que sea delivery y que venga
                // pagado antes de hacerle caso, asi que esto es solo la senal.
                cerrar_inmediato: datosVenta.cerrar_inmediato !== undefined
                    ? (Boolean(datosVenta.cerrar_inmediato) && datosVenta.metodo_pago !== 'PENDIENTE_PAGO')
                    : (cerrarDeliveryPagado && esDelivery && datosVenta.metodo_pago !== 'PENDIENTE_PAGO'),
                observacion: datosVenta.observacion || info.observacion || "",
                descuento_aplicado: (datosVenta.descuento_porcentaje !== undefined && datosVenta.descuento_porcentaje !== null)
                    ? datosVenta.descuento_porcentaje
                    : descuentoGlobal,
                monto_descuento: ahorro,
                costo_envio: costoDelEnvio,
                lugar_consumo: lugarConsumoFinal,
                lat: info.lat, // 🚩 Capturamos la latitud del modal del cliente
                lng: info.lng, // 🚩 Capturamos la longitud del modal del cliente
                // 🚩 Pedidos programados
                fecha_entrega_programada: info.fecha_programada || null,
                terminal_nombre: localStorage.getItem('terminalNombre') || null,
            };

            console.log("Comanda data", comandaData)


            const res = await registrarPedidoTPV(comandaData);

            if (res && res.id) {
                setPropinaSeleccionada(0);
                dispararExitoVenta();
                const datosParaRecordar = { ...comandaData, id: res.id, display_id: res.display_id, lugar_consumo: lugarConsumoFinal };
                setUltimaVenta(datosParaRecordar);
                localStorage.setItem('ultima_venta_tpv', JSON.stringify(datosParaRecordar));

                // 🚩 CAMBIO 2: La comanda SIEMPRE se imprime (para que cocina trabaje)
                ejecutarImpresionTPV(datosParaRecordar, 'SOLO_COMANDA', ajustesImpresion);

                // 🚩 CAMBIO 3: El recibo se imprime SOLO si no es PENDIENTE, NO es DELIVERY y el flag IMPRIMIR_RECIBO está activo
                const imprimirReciboTPV = ajustesImpresion && ajustesImpresion.IMPRIMIR_RECIBO !== false;
                if (imprimirReciboTPV && datosVenta.metodo_pago !== 'PENDIENTE_PAGO' && !esDelivery) {
                    setTimeout(() => {
                        ejecutarImpresionTPV(datosParaRecordar, 'SOLO_RECIBO', ajustesImpresion);
                    }, 1200);
                }

                // 🚩 En DELIVERY sale un ticket de DESPACHO en vez del recibo.
                // El recibo dice "RECIBO VENTA" e implica pago, y en delivery
                // normalmente todavia no se cobro. El despacho lleva lo que el
                // repartidor necesita: direccion, telefono y total a cobrar.
                // La comanda de arriba no sirve para eso: es para cocina y no
                // incluye la direccion.
                if (esDelivery) {
                    // 🚩 QR de cierre: URL firmada por el backend, se pide antes
                    // de imprimir. Si falla, el ticket sale igual, sin el QR.
                    try {
                        const urlCierre = await obtenerUrlCierreDespacho(res.id);
                        if (urlCierre && urlCierre.res && urlCierre.url_cierre) {
                            datosParaRecordar.url_cierre = urlCierre.url_cierre;
                        }
                    } catch (errUrl) {
                        console.error('No se pudo obtener la url de cierre:', errUrl);
                    }
                    setTimeout(() => {
                        ejecutarImpresionTPV(datosParaRecordar, 'SOLO_DESPACHO', ajustesImpresion);
                    }, 1200);
                }

                // Limpieza total
                setCarro([]);
                setDescuentoGlobal(0);
                setValorDescuentoInput('');
                setModalPagoAbierto(false);
                setModalClienteAbierto(false);
                // Volver a modo mostrador: si no, la próxima venta hereda
                // TELEFONO_RETIRO/DELIVERY y se guarda con el tipo equivocado.
                setTipoVenta('USUARIO_PRESENCIAL');
                setFinalOrder({ cartItems: [], total: 0, id_actualizar: null });
                if (fetchPedidosWeb) fetchPedidosWeb();
            }
        } catch (e) {
            console.error("Error al registrar venta:", e);
            alert("Ocurrió un error al guardar el pedido.");
        }
    };




    const handleReimpresion = async () => {

        if (!ultimaVenta) {
            alert("No hay ventas recientes para reimprimir.");
            return;
        }
        ejecutarImpresionTPV(ultimaVenta, 'TODO', ajustesImpresion);
    };

    //Vdalida Descuento
    const validarDescuento = async () => {

        if (carro.length === 0) {
            alert("Debes agregar productos al carrito antes de aplicar un descuento.");
            return;
        }

        const porcentaje = Number(valorDescuentoInput);
        if (porcentaje < 0 || porcentaje > 100) {
            alert("El descuento debe ser entre 0 y 100");
            return;
        }

        try {
            const token = localStorage.getItem("token");
            // AQUÍ LLAMAS A TU ENDPOINT DE VALIDACIÓN
            const res = await fetch(config.api_url + "api/v1/validar_descuento", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'token': token },
                body: JSON.stringify({ porcentaje: porcentaje })
            });

            if (res.ok) {
                setDescuentoGlobal(porcentaje);
                setModalDescuentoAbierto(false);
                setValorDescuentoInput('');
                alert("Descuento aplicado correctamente");
            } else {
                alert("Código o porcentaje inválido");
            }
        } catch (e) {
            console.error("Error validando descuento", e);
        }
    };

    // const { bloqueado, motivo } = useLicencia('POS');
    // if (bloqueado) return <PantallaBloqueo motivo={motivo} />;

    // El selector de entrega (F9) trabaja sobre el carrito vivo. Hay que copiarlo
    // a finalOrder antes de abrir el modal del cliente; si no, el pedido se
    // guarda con items pero con total $0.
    const prepararOrdenTelefonica = () => {
        const total = carro.reduce(
            (acc, it) => acc + (Number(it.precio || it.valor || 0) * Number(it.cantidad || 1)), 0
        );
        setFinalOrder({ cartItems: carro, total, id_actualizar: null, lugar_consumo: 'LLEVAR' });
        return total;
    };
    const seleccionarRetiro = () => { setTipoVenta('TELEFONO_RETIRO'); setModalSelectorEntrega(false); prepararOrdenTelefonica(); setModalClienteAbierto(true); };
    const seleccionarDelivery = () => { setTipoVenta('TELEFONO_DELIVERY'); setModalSelectorEntrega(false); prepararOrdenTelefonica(); setModalClienteAbierto(true); };


    const pedidosWebActivos = pedidosWeb.filter(o => {
        if (o.status === 'Entregada' || o.status === 'Cancelada') return false;

        const origen = String(o.origen || o.plataforma_origen || '').toUpperCase();

        // 1. Agregamos 'MESA' a los orígenes permitidos por si el backend lo manda así
        const origenesPermitidos = ['WEB', 'MOSTRADOR', 'TPV', 'TELEFONO', 'MESA'];
        if (!origenesPermitidos.some(op => origen.includes(op))) return false;

        // 2. 🚩 EXCEPCIÓN PARA MESAS POR COBRAR: Si es estado 7, lo mostramos siempre.
        const estadoId = Number(o.statusId || o.estado_id || 0);
        if (estadoId === 7) return true;

        // 3. Si es de una MESA pero NO está en estado 7, lo ocultamos.
        // (No queremos que las mesas comiendo ocupen la pantalla del TPV)
        if (origen.includes('MESA')) return false;

        // 4. LÓGICA ORIGINAL INTACTA: Solo deja pasar Delivery (2) y Retiro (3) de los otros orígenes
        if (o.tipo_entrega_id) {
            const id = Number(o.tipo_entrega_id);
            return (id === 2 || id === 3);
        }
        const tipoTexto = String(o.type || '').toUpperCase();
        return (tipoTexto.includes('DELIVERY') || tipoTexto.includes('RETIRO'));
    });

    const cantidadNuevos = pedidosWebActivos.filter(o => o.status === 'Recibida').length;



    // 🚩 NUEVA FUNCIÓN: Maneja tanto agregar como editar items del carro
    const handleConfirmarPersonalizado = (itemFinal) => {
        if (editandoItemId) {
            // 🚩 MODO EDICIÓN: Reemplazamos el item existente en el carro
            setCarro(prev => prev.map(item =>
                item.id === editandoItemId ? { ...itemFinal, id: editandoItemId } : item
            ));
            setEditandoItemId(null);
        } else {
            // 🚩 MODO NUEVO: Agregamos al carro
            setCarro(prev => [...prev, itemFinal]);
        }
        setItemParaPersonalizar(null);
        if (modoCarrito === 'flotante') setMostrarCarro(true);
    };

    // 🚩 FIX ALTURA: la ruta /ventas/tpv muestra la barra superior del menú
    // (65px, position fixed + padding-top compensatorio en .contenedorPrincipal).
    // Si el TPV fuerza 100vh igual, se pasa 65px del viewport y el botón de
    // cobrar queda cortado en pantallas de poca altura (13-15"). La ruta
    // /ventas/pos/ es la variante fullscreen sin menú y sí necesita 100vh real.
    const alturaDisponible = window.location.pathname.startsWith('/ventas/pos/') ? '100vh' : 'calc(100vh - 65px)';

    return (
        <div className="tpv-window" style={{ display: 'flex', flexDirection: 'column', height: alturaDisponible, maxHeight: alturaDisponible, overflow: 'hidden', minHeight: 0 }}>
            <ThemeInjector configuracion={configNegocio} />

            <style>{`
                /* 🚩 ESTILOS RESPONSIVE PARA MÓVIL */
                @media (max-width: 767px) {
                    .modal-content-box {
                        width: 92vw !important;
                        max-width: 92vw !important;
                        margin: 0 auto;
                        padding: 16px !important;
                    }
                    .modal-content-box-lg {
                        width: 95vw !important;
                        max-width: 95vw !important;
                        padding: 12px !important;
                    }
                    /* Botón confirmar compra más grande en móvil */
                    .btn-checkout-mobile {
                        min-height: 56px;
                        font-size: 1.1rem !important;
                    }
                }

                /* --- ESTILOS DEL BANNER DE DEUDA --- */
                .global-billing-banner {
                    color: white; padding: 8px 24px; display: flex;
                    justify-content: center; align-items: center;
                    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3); z-index: 1050; flex-shrink: 0;
                }
                .billing-text-content {
                    display: flex; align-items: center; font-size: 0.9rem; font-weight: 500;
                }
                .pulse-alert-icon {
                    font-size: 1.2rem; color: #fff; animation: alert-pulse-deuda 1.5s infinite;
                }
                @keyframes alert-pulse-deuda {
                    0% { transform: scale(1); opacity: 1; }
                    50% { transform: scale(1.3); opacity: 0.5; color: #fca5a5; }
                    100% { transform: scale(1); opacity: 1; }
                }
                .btn-regularizar {
                    background-color: white;
                    color: #dc2626;
                    border: none;
                    font-weight: 800;
                    padding: 6px 16px;
                    border-radius: 20px;
                    font-size: 0.8rem;
                    text-transform: uppercase;
                    transition: all 0.2s;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
                }

                .btn-regularizar:hover {
                    background-color: #fef2f2;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
                }
                * Animación del mensaje de éxito */
                @keyframes slide-in-top {
                    0% { transform: translateY(-100px); opacity: 0; }
                    100% { transform: translateY(0); opacity: 1; }
                }

                .alerta-venta-exitosa {
                    position: fixed;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 9999;
                    background: #28a745;
                    color: white;
                    padding: 15px 30px;
                    border-radius: 50px;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
                    animation: slide-in-top 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
                }

                .alerta-venta-exitosa i {
                    font-size: 1.5rem;
                    background: rgba(255,255,255,0.2);
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                @keyframes bell-ring {
                    0% { transform: rotate(0); } 10% { transform: rotate(15deg); } 20% { transform: rotate(-15deg); }
                    30% { transform: rotate(10deg); } 40% { transform: rotate(-10deg); } 50% { transform: rotate(5deg); }
                    60% { transform: rotate(-5deg); } 70% { transform: rotate(0); } 100% { transform: rotate(0); }
                }
                .bell-anim { animation: bell-ring 2s infinite; }

                @keyframes border-blink-red {
                    0% { border-color: rgba(220, 53, 69, 0.3); box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
                    50% { border-color: rgba(220, 53, 69, 1); box-shadow: 0 0 10px 2px rgba(220, 53, 69, 0.5); }
                    100% { border-color: rgba(220, 53, 69, 0.3); box-shadow: 0 0 0 0 rgba(220, 53, 69, 0); }
                }
                .alerta-pedido-web { border: 2px solid #dc3545 !important; animation: border-blink-red 1.5s infinite ease-in-out; z-index: 10; }
                
                @keyframes pulse-red-bg { 0%, 100% { background-color: #dc3545; } 50% { background-color: #ff4d4d; } }
                .animate-pulse-red { animation: pulse-red-bg 1s infinite; }
                .hov-light:hover {
    background-color: #f1f3f5 !important;
    border-color: #dee2e6 !important;
}

.transition-all {
    transition: all 0.2s ease-in-out;
}

.rounded-xl {
    border-radius: 12px;
}

/* Para que el scroll sea más suave en el contenedor del modal */
.overflow-auto {
    scroll-behavior: smooth;
}

/* Esto obliga a que cualquier movimiento de scroll en este div sea suave */
.contenedor-variantes-scroll {
    scroll-behavior: smooth !important;
    overflow-y: auto;
    /* Añadimos un padding al tope para que al scrollear el título no quede pegado al borde */
    scroll-padding-top: 20px; 
}

/* Estilo para los botones laterales para que se vean bien grandes */
.btn-navegacion-tpv {
    width: 65px !important;
    height: 65px !important;
    border: 3px solid white !important;
    font-size: 1.5rem !important;
    transition: transform 0.2s;
}

.btn-navegacion-tpv:active {
    transform: scale(0.9);
}

.productos-grid-container {
    display: grid;
    /* En móvil: 2 columnas fijas. En desktop: se llena según el espacio */
    grid-template-columns: repeat(2, 1fr); 
    gap: 12px;
    padding: 10px;
}

@media (min-width: 768px) {
    .productos-grid-container {
        /* Aquí el grid decide solo cuántos caben según el tamaño de la tarjeta */
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
        gap: 16px;
    }
}
    .carrito-lateral-container {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
}

            `}</style>

            <div className="tpv-header bg-white shadow-sm border-bottom" style={{ flexShrink: 0 }}>
                {/* 🚨 BANNER DE DEUDA 🚨 — DESHABILITADO TEMPORALMENTE */}
                {/* FIN DEL BANNER */}


                <div className="container-fluid py-2">
                    {/* Fila del Buscador y Botones */}
                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>

                        {/* Buscador angosto, pegado a la izquierda */}
                        <div style={{ width: esMobile ? '100%' : '320px', flexShrink: 0 }}>
                            <Buscador
                                termino={terminoBusqueda}
                                setTermino={setTerminoBusqueda}
                                productos={productosBase}
                                agregarAlCarro={agregarAlCarro}
                            />
                        </div>

                        {/* 🚩 EN MÓVIL: Solo mostramos íconos compactos */}
                        {esMobile ? (
                            <div className="d-flex" style={{ gap: '6px', flexShrink: 0 }}>
                                {/* Botón Pedidos Web como ícono */}
                                <button
                                    className={`btn btn-sm rounded-circle shadow-sm ${cantidadNuevos > 0 ? 'btn-danger text-white' : 'btn-dark text-warning'}`}
                                    style={{ width: '42px', height: '42px', position: 'relative' }}
                                    onClick={() => setMostrarPedidosWeb(true)}
                                    title="Pedidos Web"
                                >
                                    <i className={`fas fa-bell fa-sm ${cantidadNuevos > 0 ? 'bell-anim' : ''}`}></i>
                                    {pedidosWebActivos.length > 0 && (
                                        <span className="badge badge-warning text-dark position-absolute border border-dark"
                                            style={{ top: '-4px', right: '-4px', fontSize: '0.6rem', padding: '2px 4px' }}>
                                            {pedidosWebActivos.length}
                                        </span>
                                    )}
                                </button>

                                {/* Botón Reimpresión */}
                                <button
                                    className="btn btn-sm btn-outline-secondary rounded-circle shadow-sm"
                                    style={{ width: '42px', height: '42px' }}
                                    onClick={handleReimpresion}
                                    disabled={!ultimaVenta}
                                    title="Reimprimir"
                                >
                                    <i className="fas fa-print fa-sm"></i>
                                </button>

                                {/* Botón más opciones (despliega menú) */}
                                <button
                                    className="btn btn-sm btn-outline-dark rounded-circle shadow-sm"
                                    style={{ width: '42px', height: '42px' }}
                                    onClick={() => setModalDescuentoAbierto(true)}
                                    title="Más opciones"
                                >
                                    <i className="fas fa-ellipsis-v fa-sm"></i>
                                </button>
                            </div>
                        ) : (
                            /* 🚩 EN DESKTOP: Todos los botones visibles */
                            <div className="btn-group shadow-sm" style={{ flexShrink: 0 }}>
                                {tieneMesas && (
                                    <button
                                        className="btn btn-md btn-outline-info font-weight-bold ml-2 shadow-sm"
                                        onClick={() => {
                                            setModalCorreccionAbierto(true);
                                            obtenerMesasActivas();
                                        }}
                                        title="Corregir errores en mesas abiertas"
                                    >
                                        <i className="fas fa-edit mr-1"></i> CORREGIR MESA
                                    </button>
                                )}
                                <button
                                    className="btn btn-md btn-outline-secondary font-weight-bold ml-2 shadow-sm"
                                    onClick={handleReimpresion}
                                    disabled={!ultimaVenta}
                                    title="Reimprimir último ticket"
                                >
                                    <i className="fas fa-print mr-1"></i> {ultimaVenta ? `#${ultimaVenta.display_id}` : ''}
                                </button>
                                <button
                                    className="btn btn-md btn-outline-secondary font-weight-bold ml-2 shadow-sm"
                                    onClick={toggleCatLayout}
                                    title={catHorizontal ? 'Cambiar a categorías verticales' : 'Cambiar a categorías horizontales'}
                                >
                                    <i className={`fas ${catHorizontal ? 'fa-th-list' : 'fa-grip-horizontal'} mr-1`}></i>
                                    {catHorizontal ? 'Vertical' : 'Horizontal'}
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Categorías: se movieron a la barra lateral izquierda del contenido */}
                </div>
            </div>

            <div className="tpv-content px-0 pb-0" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}>
                {/* CONTENEDOR PRINCIPAL DIVIDIDO */}
                <div style={{ display: 'flex', width: '100%', height: '100%', flex: 1, minHeight: 0 }}>


                    {/* BARRA LATERAL DE CATEGORÍAS (solo desktop vertical; en mobile/horizontal va arriba de los productos) */}
                    {!esMobile && !catHorizontal && (
                        <div
                            className="h-100 border-right bg-white"
                            style={{ width: '150px', flexShrink: 0, overflowY: 'auto', padding: '8px 6px' }}
                        >
                            <button
                                className={`btn btn-sm btn-block text-left mb-1 py-1 ${categoriaActual === null ? 'btn-primary shadow-sm' : 'btn-light border'}`}
                                onClick={() => setCategoriaActual(null)}
                            >
                                Todos
                            </button>
                            {categorias.map(c => (
                                <button
                                    key={c.uuid}
                                    className={`btn btn-sm btn-block text-left mb-1 py-1 ${categoriaActual === c.id ? 'btn-primary shadow-sm' : 'btn-light border'}`}
                                    onClick={() => setCategoriaActual(c.id)}
                                >
                                    {c.nombre}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* ÁREA DE PRODUCTOS (70% en fijo, 100% en flotante) */}
                    <div
                        className="h-100"
                        style={{
                            width: modoCarrito === 'fijo' ? '70%' : '100%',
                            overflowY: 'auto',
                            transition: 'width 0.3s ease'
                        }}
                    >
                        {(esMobile || catHorizontal) && (
                            <MenuCategorias
                                categorias={categorias}
                                categoriaActual={categoriaActual}
                                onSeleccionarCategoria={setCategoriaActual}
                            />
                        )}
                        <div className="tpv-products-area w-100">
                            <div className="productos-grid-container">
                                {productosFiltrados.map(p => (
                                    <Item
                                        key={p.id}
                                        item={{ ...p, url_imagen: obtenerUrlImagen(p) }}
                                        agregarAlCarro={agregarAlCarro}
                                        onPersonalizarItem={handlePersonalizarItem}
                                        carro={carro}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* 🚩 CARRITO FIJO (Solo en desktop, modo fijo) */}
                    {modoCarrito === 'fijo' && (
                        <div
                            className="border shadow-sm bg-white"
                            style={{
                                width: '30%',
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                position: 'relative',
                                overflow: 'hidden',
                                borderRadius: '15px 15px 0 0',
                                marginBottom: 0
                            }}
                        >
                            <CarritoLateral
                                carro={carro}
                                setCarro={setCarro}
                                mostrar={true}
                                toggleCarro={() => {}}
                                confirmarCompra={confirmarCompra}
                                tipoVenta={tipoVenta}
                                setTipoVenta={setTipoVenta}
                                onPersonalizarItem={handlePersonalizarItem}
                                modoFijo={true}
                                descuentoGlobal={descuentoGlobal}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* 🚩 BOTONES FLOTANTES + BARRA MÓVIL: solo en modo flotante */}
            {modoCarrito === 'flotante' && !esMobile && (
                <div className="position-fixed" style={{
                    bottom: '20px',
                    right: '340px',
                    zIndex: 1000
                }}>
                    <button className="btn btn-primary rounded-circle shadow-lg d-flex align-items-center justify-content-center"
                        style={{ width: '65px', height: '65px' }}
                        onClick={() => setMostrarCarro(true)}>
                        <i className="fas fa-shopping-cart fa-lg"></i>
                        {carro.length > 0 && <span className="badge badge-danger position-absolute" style={{ top: '-4px', right: '-4px', fontSize: '0.8rem', padding: '3px 6px' }}>{carro.reduce((s, i) => s + Number(i.cantidad || 0), 0)}</span>}
                    </button>
                </div>
            )}

            {/* 🚩 BOTÓN ALARMA WEB (Siempre en desktop, independiente del modo carrito) */}
            {!mostrarPedidosWeb && !esMobile && (
                <div className="position-fixed" style={{
                    bottom: '20px',
                    left: '20px',
                    zIndex: 1000
                }}>
                    <button
                        className={`btn rounded-circle shadow-lg d-flex align-items-center justify-content-center ${cantidadNuevos > 0 ? 'btn-danger text-white' : 'btn-dark text-warning'}`}
                        style={{ width: '65px', height: '65px', border: cantidadNuevos > 0 ? '2px solid #fff' : 'none' }}
                        onClick={() => setMostrarPedidosWeb(true)}
                    >
                        <i className={`fas fa-bell fa-lg ${cantidadNuevos > 0 ? 'bell-anim' : ''}`}></i>
                        {pedidosWebActivos.length > 0 && (
                            <span className="badge badge-warning text-dark position-absolute border border-dark" style={{ top: '-4px', right: '-4px', fontSize: '0.8rem', padding: '2px 6px' }}>
                                {pedidosWebActivos.length}
                            </span>
                        )}
                    </button>
                </div>
            )}

            {/* 🚩 BARRA DE NAVEGACIÓN INFERIOR PARA MÓVIL (z-index 1051 para estar sobre el panel) */}
            {esMobile && (
                <div className="position-fixed bg-dark shadow-lg d-flex justify-content-around align-items-center"
                    style={{
                        bottom: 0, left: 0, right: 0, height: '60px', zIndex: 1051,
                        borderTop: '1px solid #444', paddingBottom: 'env(safe-area-inset-bottom, 0px)'
                    }}>
                    {/* Productos - Cierra todo */}
                    <div className="text-center text-white-50" style={{ flex: 1, opacity: 0.5 }}
                        onClick={() => {
                            setMostrarPedidosWeb(false);
                            setMostrarCarro(false);
                        }}>
                        <i className="fas fa-th-large" style={{ fontSize: '1.3rem' }}></i>
                        <div style={{ fontSize: '0.6rem', marginTop: '2px' }}>Productos</div>
                    </div>

                    {/* Carrito */}
                    <div className="text-center text-white position-relative" style={{ flex: 1 }} onClick={() => setMostrarCarro(true)}>
                        <i className="fas fa-shopping-cart" style={{ fontSize: '1.3rem' }}></i>
                        {carro.length > 0 && (
                            <span className="badge badge-danger position-absolute"
                                style={{ top: '-6px', right: '50%', transform: 'translateX(14px)', fontSize: '0.6rem', padding: '2px 5px' }}>
                                {carro.reduce((s, i) => s + Number(i.cantidad || 0), 0)}
                            </span>
                        )}
                        <div style={{ fontSize: '0.6rem', marginTop: '2px' }}>Carrito</div>
                    </div>

                    {/* Pedidos Web */}
                    <div className="text-center text-white position-relative" style={{ flex: 1 }} onClick={() => setMostrarPedidosWeb(true)}>
                        <i className={`fas fa-bell ${cantidadNuevos > 0 ? 'bell-anim' : ''}`} style={{ fontSize: '1.3rem' }}></i>
                        {pedidosWebActivos.length > 0 && (
                            <span className="badge badge-warning text-dark position-absolute"
                                style={{ top: '-6px', right: '50%', transform: 'translateX(14px)', fontSize: '0.6rem', padding: '2px 5px' }}>
                                {pedidosWebActivos.length}
                            </span>
                        )}
                        <div style={{ fontSize: '0.6rem', marginTop: '2px' }}>Pedidos</div>
                    </div>

                    {/* Más Opciones */}
                    <div className="text-center text-white-50" style={{ flex: 1, opacity: 0.5 }}
                        onClick={() => setModalDescuentoAbierto(true)}>
                        <i className="fas fa-ellipsis-h" style={{ fontSize: '1.3rem' }}></i>
                        <div style={{ fontSize: '0.6rem', marginTop: '2px' }}>Más</div>
                    </div>
                </div>
            )}

            {/* 🚩 PANEL LATERAL SIMPLE (overlay completo con botón CERRAR visible) */}
            {mostrarPedidosWeb && (
                <div
                    onClick={() => setMostrarPedidosWeb(false)}
                    style={{
                        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                        backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060,
                        display: 'flex', flexDirection: 'column'
                    }}>
                    <div onClick={e => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', height: '100%', maxWidth: esMobile ? '100%' : '400px', alignSelf: esMobile ? 'stretch' : 'flex-start' }}>
                        {/* Barra superior con botón cerrar */}
                        <div style={{
                            flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '10px 16px', backgroundColor: '#1a1a2e', borderBottom: '3px solid #ffc107',
                            margin: '0', minHeight: '50px'
                        }}>
                            <span style={{ color: '#ffc107', fontWeight: 700, fontSize: '1rem' }}>
                                <i className="fas fa-globe mr-2"></i>Monitor Web ({pedidosWebActivos.length})
                            </span>
                            <button
                                onClick={() => setMostrarPedidosWeb(false)}
                                style={{
                                    backgroundColor: '#dc3545', color: '#fff', border: 'none',
                                    padding: '10px 20px', borderRadius: '8px', fontWeight: 700,
                                    fontSize: '0.9rem', cursor: 'pointer'
                                }}>
                                ✕ CERRAR
                            </button>
                        </div>
                        {/* Contenido scrolleable */}
                        <div style={{ flex: 1, overflowY: 'auto', backgroundColor: '#f8f9fa', padding: '10px' }}>
                            {pedidosWebActivos.length === 0 ? (
                                <div className="text-center p-5 text-muted">
                                    <i className="fas fa-check-circle fa-3x mb-3 text-success opacity-50"></i>
                                    <h5>Todo al día</h5>
                                    <small>No hay pedidos pendientes</small>
                                </div>
                            ) : (
                                pedidosWebActivos.map(order => {
                                    const lugarConsumo = order.lugar_consumo || 'LLEVAR';
                                    const origen = String(order.origen || '').toUpperCase();
                                    const tipoTexto = String(order.type || '').toUpperCase();
                                    const esWeb = origen.includes('WEB') || String(order.display_id).toUpperCase().includes('W');
                                    const estaPagado = Number(order.pagado) === 1 || Number(order.payment_status) === 1;
                                    const estadoId = Number(order.statusId || order.estado_id || 0);
                                    const esPorCobrar = estadoId === 7;
                                    const esMesa = origen.includes('MESA') || esPorCobrar;
                                    let esDelivery = false;
                                    if (order.tipo_entrega_id) { esDelivery = (order.tipo_entrega_id == 2); }
                                    else { esDelivery = tipoTexto.includes('DELIVERY'); }
                                    const costoDeEnvio = Number(order.costo_envio || order.costo_delivery || 0);
                                    const iconoEntrega = esDelivery ? 'fa-motorcycle' : 'fa-shopping-bag';
                                    const textoEntrega = esDelivery ? 'DELIVERY' : 'RETIRO';
                                    const colorBadge = esDelivery ? 'badge-warning' : 'badge-info';
                                    const claseAnimacion = (esWeb && order.status === 'Recibida') ? 'alerta-pedido-web' : '';
                                    const tiempoPedido = calcularTranscurrido(order);
                                    let bgHeader = 'bg-secondary';
                                    let textHeader = 'text-white';
                                    if (esPorCobrar) { bgHeader = 'bg-warning'; textHeader = 'text-dark'; }
                                    else if (esWeb && order.status === 'Recibida') { bgHeader = 'bg-dark'; }
                                    else if (estaPagado) { bgHeader = 'bg-success'; }
                                    const nombreCliente = order.customer ? (order.customer.name || order.customer.nombre) : (order.cliente_nombre || 'Cliente');
                                    const dirCliente = order.customer ? (order.customer.address || order.customer.direccion) : (order.direccion || 'Sin Dirección');
                                    const esWebReal = String(order.display_id).includes('W');
                                    const totalBrutoBD = Number(order.total || 0) + (esWebReal ? Number(order.costo_envio || 0) : 0);
                                    const descValor = Number(order.descuento_valor || 0);
                                    const subtotalComida = totalBrutoBD - costoDeEnvio + descValor;
                                    const porcPropina = Number(ajustesImpresion && ajustesImpresion.PORCENTAJE_PROPINA || 0);
                                    const propinaMesas = ajustesImpresion && ajustesImpresion.PROPINA_MESAS === true;
                                    const propinaCard = (esMesa && propinaMesas && porcPropina > 0) ? Math.round(subtotalComida * (porcPropina / 100)) : 0;
                                    const granTotalCard = totalBrutoBD + propinaCard;
                                    // 🚩 Add-on Pedidos QR: el cliente pidio la cuenta desde
                                    // su telefono. Viene apagado si el negocio no tiene el add-on.
                                    const pideLaCuenta = Boolean(order.cuenta_solicitada);
                                    return (
                                        <div key={order.id} className={`card mb-3 shadow-sm ${claseAnimacion} ${esPorCobrar ? 'border-warning' : ''}`} style={{ borderRadius: '15px', overflow: 'hidden', border: pideLaCuenta ? '2px solid #fd7e14' : '1px solid #eee', cursor: 'pointer' }} onClick={(e) => verDetallePedido(e, order)}>
                                            <div className={`p-2 d-flex justify-content-between align-items-center ${bgHeader} ${textHeader}`}>
                                                <div className="d-flex align-items-center">
                                                    <span className="font-weight-bold mr-2">#{order.display_id}</span>
                                                    {order.mesa_nombre && (
                                                        <span className="badge bg-warning text-dark mr-2" style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>🪑 {order.mesa_nombre}</span>
                                                    )}
                                                    {esPorCobrar ? (
                                                        <span className="badge badge-danger mr-2 animate-pulse-red" style={{ fontSize: '0.7rem' }}>💰 POR COBRAR</span>
                                                    ) : (
                                                        <span className={`badge ${lugarConsumo === 'SERVIR' ? 'bg-info border border-white text-white' : 'bg-dark opacity-75 text-white'} mr-2`} style={{ fontSize: '0.7rem' }}>
                                                            {lugarConsumo === 'SERVIR' ? '🍽️ SERVIR' : '🥡 LLEVAR'}
                                                        </span>
                                                    )}
                                                    <span className="badge badge-light text-dark text-uppercase mr-2" style={{ fontSize: '0.65rem' }}>{origen}</span>
                                                    <span className={`badge ${tiempoPedido.atrasado ? 'animate-pulse-red text-white' : 'bg-dark text-white border border-secondary'} px-2 py-1`}>
                                                        <i className="far fa-clock mr-1"></i> {tiempoPedido.texto}
                                                    </span>
                                                </div>
                                                <span className={`badge ${colorBadge} text-dark font-weight-bold`}>
                                                    <i className={`fas ${iconoEntrega} mr-1`}></i> {textoEntrega}
                                                </span>
                                            </div>
                                            {/* 🚩 Add-on Pedidos QR: va arriba de "pendiente de pago"
                                                porque es lo accionable — el cliente esta esperando
                                                que alguien le vaya a cobrar. */}
                                            {pideLaCuenta && (
                                                <div className="text-white text-center small font-weight-bold p-1 animate-pulse-red" style={{ backgroundColor: '#fd7e14' }}>
                                                    <i className="fas fa-hand-paper mr-1"></i> EL CLIENTE PIDIÓ LA CUENTA
                                                </div>
                                            )}
                                            {!estaPagado && !esPorCobrar && (
                                                <div className="bg-danger text-white text-center small font-weight-bold p-1">
                                                    <i className="fas fa-exclamation-circle mr-1"></i> PENDIENTE DE PAGO
                                                </div>
                                            )}
                                            {order.status === 'EnReparto' && (
                                                <div className="bg-warning text-dark text-center small font-weight-bold p-1 border-bottom">
                                                    <i className="fas fa-motorcycle mr-1"></i> MOTO EN RUTA...
                                                </div>
                                            )}
                                            <div className="p-2 bg-white">
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <div className="font-weight-bold text-dark text-truncate" style={{ maxWidth: '60%' }}>
                                                        <i className="fas fa-user mr-1 text-muted"></i>
                                                        {nombreCliente}
                                                    </div>
                                                    <div className="d-flex flex-column align-items-end">
                                                        <div className="font-weight-bold text-primary h5 m-0" title="Total sin propina">
                                                            ${totalBrutoBD.toLocaleString('es-CL')}
                                                        </div>
                                                        {propinaCard > 0 && (
                                                            <div className="small text-info font-weight-bold" style={{ fontSize: '0.75rem', marginTop: '-2px' }}>
                                                                + ${propinaCard.toLocaleString('es-CL')} prop. sug.
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="small text-muted mb-2 text-truncate">
                                                    <i className="fas fa-map-marker-alt mr-1 text-danger"></i>
                                                    {esDelivery ? dirCliente : 'Retiro en Local'}
                                                </div>
                                                <div className="mt-2">
                                                    {esPorCobrar ? (
                                                        <button className="btn btn-warning btn-block font-weight-bold shadow-sm" onClick={(e) => { e.stopPropagation(); retomarPedido(order); }}>
                                                            <i className="fas fa-cash-register mr-2"></i> RECIBIR PAGO
                                                        </button>
                                                    ) : (
                                                        <>
                                                            {esWeb && order.status === 'Recibida' && (
                                                                <button className="btn btn-warning btn-block font-weight-bold shadow-sm" onClick={(e) => handleImprimirYPreparar(e, order)}>
                                                                    <i className="fas fa-print mr-2"></i> IMPRIMIR Y PREPARAR
                                                                </button>
                                                            )}
                                                            {((!esWeb) || (esWeb && order.status !== 'Recibida')) && (
                                                                <button className={`btn btn-block font-weight-bold shadow-sm mt-2 ${order.status === 'EnReparto' ? 'btn-info' : (estaPagado ? 'btn-success' : 'btn-dark')}`} onClick={(e) => handleDespachar(e, order)}>
                                                                    <i className={`fas ${order.status === 'EnReparto' ? 'fa-flag-checkered' : (esDelivery ? 'fa-motorcycle' : 'fa-hand-holding')} mr-2`}></i>
                                                                    {order.status === 'EnReparto' ? (estaPagado ? 'FINALIZAR RUTA' : 'RECIBIR PAGO DE CHOFER') : (esDelivery ? (estaPagado ? 'ENVIAR A REPARTO' : 'ENVIAR (PENDIENTE PAGO)') : (estaPagado ? 'ENTREGAR CLIENTE' : 'COBRAR PARA ENTREGAR'))}
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* MODALES */}
            {modalDescuentoAbierto && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 3000, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.7)' }}>
                    <div className="bg-white p-4 rounded shadow-lg" style={{ width: '350px' }}>
                        <h5 className="font-weight-bold mb-3"><i className="fas fa-tags text-warning mr-2"></i> Aplicar Descuento (%)</h5>
                        <div className="form-group">
                            <input
                                type="number"
                                className="form-control form-control-lg"
                                placeholder="Ej: 10"
                                value={valorDescuentoInput}
                                onChange={(e) => setValorDescuentoInput(e.target.value)}
                                onKeyDown={(e) => { if (e.key === 'Enter') validarDescuento(); }} // <--- ¡AQUÍ LA MAGIA!
                                autoFocus
                            />
                        </div>
                        <div className="d-flex justify-content-end mt-3" style={{ gap: '10px' }}>
                            <button className="btn btn-secondary" onClick={() => setModalDescuentoAbierto(false)}>Cancelar</button>
                            <button className="btn btn-warning" onClick={validarDescuento}
                            >Aplicar</button>
                        </div>
                    </div>
                </div>
            )}
            <CarritoLateral
                    carro={carro}
                    setCarro={setCarro}
                    mostrar={mostrarCarro}
                    toggleCarro={() => setMostrarCarro(!mostrarCarro)}
                    confirmarCompra={confirmarCompra}
                    tipoVenta={tipoVenta}
                    setTipoVenta={setTipoVenta}
                    onPersonalizarItem={handlePersonalizarItem}
                    modoFijo={false}
                    descuentoGlobal={descuentoGlobal}
                />
            {modalSelectorEntrega && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1300, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(5px)' }}>
                    <div className="bg-white p-5 rounded-4 shadow-2xl text-center" style={{ maxWidth: '600px', borderRadius: '30px' }}>
                        <h2 className="font-weight-bold mb-5">¿Cómo entregamos?</h2>
                        <div className="d-flex justify-content-center" style={{ gap: '25px' }}>
                            {/* BOTÓN RETIRO (F1) */}
                            <button className="btn btn-primary d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ width: '220px', height: '220px', borderRadius: '25px' }} onClick={seleccionarRetiro}>
                                <i className="fas fa-shopping-bag mb-3" style={{ fontSize: '4rem' }}></i>
                                <span className="h3 font-weight-bold m-0 text-white">RETIRO</span>
                                <span className="badge badge-light mt-2 px-3 py-1">Presiona [F1]</span>
                            </button>
                            {/* BOTÓN DELIVERY (F2) */}
                            <button className="btn btn-success d-flex flex-column align-items-center justify-content-center shadow-lg" style={{ width: '220px', height: '220px', borderRadius: '25px' }} onClick={seleccionarDelivery}>
                                <i className="fas fa-motorcycle mb-3" style={{ fontSize: '4rem' }}></i>
                                <span className="h3 font-weight-bold m-0 text-white">DELIVERY</span>
                                <span className="badge badge-light mt-2 px-3 py-1">Presiona [F2]</span>
                            </button>
                        </div>
                        <div className="mt-5"><button className="btn btn-outline-danger px-5 rounded-pill" onClick={() => { setModalSelectorEntrega(false); setTipoVenta('USUARIO_PRESENCIAL'); }}>VOLVER [ESC]</button></div>
                    </div>
                </div>
            )}

            {/*<ModalCapturaCliente
                isVisible={modalClienteAbierto}
                onClose={() => setModalClienteAbierto(false)}
                onConfirmar={(datosCliente) => {
                    setModalClienteAbierto(false);

                    // 1. GUARDAMOS EL CLIENTE EN LA ORDEN FINAL (El state que ya tenías)
                    setFinalOrder(prev => ({ ...prev, cliente: datosCliente }));

                    // 2. DECIDIMOS EL FLUJO
                    if (tipoVenta === 'TELEFONO_RETIRO') {
                        // Si es retiro, abrimos la pregunta: ¿Paga ahora o después?
                        setModalDecisionRetiro(true);
                    } else {
                        // Si es Delivery, lo mandamos a la BD al tiro.
                        // Con CERRAR_DELIVERY_PAGADO activo entra como cobrado en
                        // efectivo, para que se cierre y no quede ocupando el panel:
                        // hay locales que ni siquiera quieren abrir esa ventana.
                        // Con el flag apagado sigue entrando como PENDIENTE, igual que siempre.
                        handlePaymentSuccessTPV({
                            cliente: datosCliente,
                            metodo_pago: cerrarDeliveryPagado ? 'EFECTIVO' : 'PENDIENTE_PAGO'
                        });
                    }
                }}
                esDelivery={tipoVenta === 'TELEFONO_DELIVERY'}
                sectores={sectores}
                totalPedido={finalOrder.total}
            />*/}

            <ModalCapturaCliente
                isVisible={modalClienteAbierto}
                isLoaded={isLoaded} // <--- ESTO ES LO QUE NECESITA EL MODAL
                usaProgramados={true}
                onClose={() => {
                    setModalClienteAbierto(false);
                    // Si se cancela la captura, no dejar la terminal pegada en
                    // modo RETIRO/DELIVERY: la siguiente venta de mostrador
                    // heredaba ese tipo y se guardaba como tipo_entrega 3.
                    if (String(tipoVenta).indexOf('TELEFONO') !== -1) {
                        setTipoVenta('USUARIO_PRESENCIAL');
                    }
                }}
                onConfirmar={async (datosCliente) => {
                    setModalClienteAbierto(false);

                    // 🚩 PASO 1: Guardamos los datos en la orden, incluyendo el lugar_consumo
                    setFinalOrder(prev => ({
                        ...prev,
                        cliente: datosCliente,
                        lugar_consumo: datosCliente.lugar_consumo // <--- GUARDADO PARA EL SIGUIENTE MODAL
                    }));

                    // 🚩 PASO 2: Decidimos el flujo
                    // Si eligió abonar, va directo a pagar (sin preguntar "ahora o al retirar")
                    if (datosCliente.es_abono && datosCliente.monto_abono > 0) {
                        setModalPagoAbierto(true);
                    } else if (tipoVenta === 'TELEFONO_RETIRO') {
                        // Si es retiro, vamos a la pregunta de pagar ahora o después
                        setModalDecisionRetiro(true);
                    } else {
                        // Si es Delivery, se guarda directo. Con CERRAR_DELIVERY_PAGADO
                        // activo entra cobrado en efectivo y se cierra al tiro; sin el
                        // flag, como PENDIENTE igual que siempre.
                        //
                        // 🚩 No decidir con flags vacíos: si la carga inicial falló,
                        // se reintenta aquí. Si aun así no hay configuración, se aborta
                        // en vez de guardar un delivery pagado como PENDIENTE_PAGO.
                        const ajustes = await asegurarAjustesActuales();
                        if (!ajustes || Object.keys(ajustes).length === 0) {
                            toast.error("No se pudo leer la configuración del negocio. Revisa la conexión e intenta de nuevo.");
                            return;
                        }

                        const cerrar = [1, true, '1'].includes(ajustes.CERRAR_DELIVERY_PAGADO);
                        handlePaymentSuccessTPV({
                            cliente: datosCliente,
                            metodo_pago: cerrar ? 'EFECTIVO' : 'PENDIENTE_PAGO',
                            lugar_consumo: datosCliente.lugar_consumo, // Lo pasamos de una vez
                            cerrar_inmediato: cerrar
                        });
                    }
                }}
                esDelivery={tipoVenta === 'TELEFONO_DELIVERY'}
                sectores={sectores}
                tipoZonas={tipoZonas}
                totalPedido={finalOrder.total}
                capacidadDiaria={ajustesImpresion.CAPACIDAD_PROGRAMADOS_DIA || 0}
            />

            {modalPagoAbierto && <PaymentModalTPV
                montoTotal={finalOrder.total}
                pedido={finalOrder}
                onClose={() => setModalPagoAbierto(false)}
                onPaymentSuccess={handlePaymentSuccessTPV}
                permiteDescuento={ajustesImpresion && ajustesImpresion.USA_DESCUENTOS === true}
                permiteDividir={ajustesImpresion && ajustesImpresion.DIVIDIR_CUENTA === true}
                tipoVenta={tipoVenta}
                metodosPersonalizados={metodosPagoPersonalizados} />}
            {itemParaPersonalizar && (
                <SelectorVariantesModal
                    item={itemParaPersonalizar}
                    editando={!!editandoItemId}
                    layoutHorizontal={(ajustesImpresion && ajustesImpresion.VARIANTES_LAYOUT_HORIZONTAL === true) || (ajustesImpresion && ajustesImpresion.VARIANTES_LAYOUT_HORIZONTAL === '1')}
                    onClose={() => {
                        setItemParaPersonalizar(null);
                        setEditandoItemId(null);
                    }}
                    onConfirm={handleConfirmarPersonalizado}
                />
            )}
            {modalPesoAbierto && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 2000, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.7)' }}>
                    <div className="bg-white p-4 rounded shadow-lg" style={{ width: '400px' }}>
                        <h5 className="font-weight-bold mb-3">Venta por Peso: {itemParaPesar ? itemParaPesar.nombre : ''}</h5>
                        <div className="form-group">
                            <label>Ingrese el monto total a pagar ($):</label>
                            <input
                                type="text" // Cambiamos a text para poder formatear
                                className="form-control form-control-lg font-weight-bold"
                                value={valorIngresado ? `$ ${Number(valorIngresado).toLocaleString('es-CL')}` : ''}
                                onChange={(e) => {
                                    // Limpiamos todo lo que no sea número
                                    const val = e.target.value.replace(/[^0-9]/g, '');
                                    setValorIngresado(val);
                                }}
                                onKeyDown={(e) => { if (e.key === 'Enter') confirmarProductoPesado(); }}
                                autoFocus
                            />
                        </div>
                        <div className="d-flex justify-content-end mt-3" style={{ gap: '10px' }}>
                            <button className="btn btn-secondary" onClick={() => setModalPesoAbierto(false)}>Cancelar</button>
                            <button className="btn btn-success" onClick={confirmarProductoPesado}>Agregar al carro</button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL DETALLE DE PEDIDO */}
            {modalDetalleAbierto && pedidoParaVer && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 2000, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(3px)' }}
                    onClick={() => { setModalDetalleAbierto(false); if (esMobile) setMostrarPedidosWeb(false); }}>
                    <div className="bg-white rounded shadow-lg p-4" style={{ width: esMobile ? '92vw' : '450px', maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>

                        {/* CABECERA */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
                            <div className="d-flex align-items-center">
                                {esMobile && (
                                    <button className="btn btn-sm btn-outline-secondary rounded-circle mr-2" onClick={() => { setModalDetalleAbierto(false); setMostrarPedidosWeb(false); }} style={{ width: '32px', height: '32px' }}>
                                        <i className="fas fa-chevron-left"></i>
                                    </button>
                                )}
                                <h5 className="font-weight-bold m-0">Detalle Pedido #{pedidoParaVer.display_id}</h5>
                            </div>
                            <button className="btn btn-sm btn-danger" onClick={() => { setModalDetalleAbierto(false); if (esMobile) setMostrarPedidosWeb(false); }}>X</button>
                        </div>

                        {/* LISTA DE PRODUCTOS */}
                        <ul className="list-group list-group-flush mb-3">
                            {pedidoParaVer.items && pedidoParaVer.items.map((item, idx) => (
                                <li key={idx} className="list-group-item d-flex justify-content-between px-0">
                                    <div>
                                        <span className="font-weight-bold">{item.cantidad}x {item.nombre}</span>
                                        <div className="small text-muted">{getVariantesTexto(item)}</div>
                                    </div>
                                    <span className="font-weight-bold">${Number(item.precio * item.cantidad).toLocaleString('es-CL')}</span>
                                </li>
                            ))}
                        </ul>

                        {/* ZONA DE TOTALES Y MAGIA */}
                        <div className="pt-2">
                            {(() => {
                                // 1. Rescatamos valores base
                                const costoEnvio = Number(pedidoParaVer.costo_envio || pedidoParaVer.costo_delivery || 0);
                                const descValor = Number(pedidoParaVer.descuento_valor || 0);
                                const descPorc = Number(pedidoParaVer.descuento_porcentaje || 0); // 🔥 ESTO FALTABA DEFINIR

                                // 2. LA VERDAD ABSOLUTA: Sumamos los items
                                const subtotalComida = (pedidoParaVer.items || []).reduce((acc, i) => acc + (Number(i.precio) * Number(i.cantidad)), 0);

                                // 3. Calculamos propina (desde parámetros del sistema)
                                const porcPropina = Number(ajustesImpresion && ajustesImpresion.PORCENTAJE_PROPINA || 0);
                                const propinaMesas = ajustesImpresion && ajustesImpresion.PROPINA_MESAS === true;
                                const esMesa = esPedidoMesa(pedidoParaVer);

                                const propinaSugerida = (esMesa && propinaMesas) ? Math.round(subtotalComida * (porcPropina / 100)) : 0;

                                // 4. TOTAL FINAL (Definimos granTotalFinal para que coincida con el HTML)
                                const granTotalFinal = subtotalComida + costoEnvio + propinaSugerida - descValor;
                                return (
                                    <>
                                        <div className="d-flex justify-content-between small text-muted mb-1">
                                            <span>Subtotal Comida</span>
                                            <span>${subtotalComida.toLocaleString('es-CL')}</span>
                                        </div>

                                        {descValor > 0 && (
                                            <div className="d-flex justify-content-between small text-success font-weight-bold mb-1">
                                                <span>Descuento ({descPorc}%)</span>
                                                <span>- ${descValor.toLocaleString('es-CL')}</span>
                                            </div>
                                        )}

                                        {costoEnvio > 0 && (
                                            <div className="d-flex justify-content-between small text-danger font-weight-bold mb-1">
                                                <span>Costo Delivery</span>
                                                <span>+ ${costoEnvio.toLocaleString('es-CL')}</span>
                                            </div>
                                        )}

                                        {propinaSugerida > 0 && (
                                            <div className="d-flex justify-content-between small text-info font-weight-bold mb-1">
                                                <span>Propina Sugerida</span>
                                                <span>+ ${propinaSugerida.toLocaleString('es-CL')}</span>
                                            </div>
                                        )}

                                        <div className="d-flex justify-content-between border-top pt-2 mt-2 font-weight-bold h5 text-primary">
                                            <span>TOTAL</span>
                                            <span>${granTotalFinal.toLocaleString('es-CL')}</span>
                                        </div>

                                        <div className="text-center mt-3 p-2 bg-light rounded small">
                                            <span className="text-uppercase font-weight-bold">Pago: </span>
                                            {pedidoParaVer.metodo_pago || 'PENDIENTE'}
                                        </div>

                                        {pedidoParaVer.url_comprobante && (
                                            <div className="text-center mt-3">
                                                <div className="fw-bold small mb-2">📎 Comprobante de pago</div>
                                                <img
                                                    src={resolveImagenUrl(pedidoParaVer.url_comprobante)}
                                                    alt="Comprobante"
                                                    style={{ maxWidth: '100%', maxHeight: '250px', borderRadius: '12px', border: '1px solid #ddd', cursor: 'pointer' }}
                                                    onClick={() => window.open(resolveImagenUrl(pedidoParaVer.url_comprobante), '_blank')}
                                                />
                                            </div>
                                        )}
                                    </>
                                );
                            })()}
                        </div>

                        {/* BOTÓN CERRAR */}
                        <button className="btn btn-primary btn-block mt-3 py-2 font-weight-bold" onClick={() => setModalDetalleAbierto(false)}>Cerrar</button>
                    </div>
                </div>
            )}
            {/* MODAL DECISIÓN RETIRO: PAGAR O GUARDAR PENDIENTE */}
            {modalDecisionRetiro && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1400, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(5px)' }}>
                    <div className="bg-white p-4 shadow-lg text-center" style={{ width: '400px', borderRadius: '20px' }}>
                        <h3 className="font-weight-bold mb-4 text-dark">Pedido de Retiro</h3>

                        {/* 👇 ESTA ES LA LÍNEA QUE EXPLOTABA. ARREGLADA SIN '?.' 👇 */}
                        <p className="text-muted mb-4">
                            Cliente: <b>{(finalOrder.cliente && finalOrder.cliente.nombreCliente) ? finalOrder.cliente.nombreCliente : 'Cliente'}</b>
                        </p>

                        <div className="d-grid gap-3">
                            {/* OPCIÓN 1: PAGA AHORA */}
                            <button
                                className="btn btn-success btn-lg w-100 font-weight-bold py-3 mb-2 shadow"
                                onClick={() => {
                                    setModalDecisionRetiro(false);
                                    // El cliente ya está en finalOrder, así que solo abrimos la caja
                                    setModalPagoAbierto(true);
                                }}
                            >
                                <i className="fas fa-cash-register mr-2"></i> PAGAR AHORA
                            </button>

                            {/* OPCIÓN 2: GUARDA EN LA BD COMO PENDIENTE INMEDIATAMENTE */}
                            <button
                                className="btn btn-primary btn-lg w-100 font-weight-bold py-3 shadow"
                                onClick={() => {
                                    setModalDecisionRetiro(false);
                                    // Ejecutamos el guardado en la BD usando el cliente que ya tenemos
                                    handlePaymentSuccessTPV({
                                        cliente: finalOrder.cliente,
                                        metodo_pago: 'PENDIENTE_PAGO'
                                    });
                                }}
                            >
                                <i className="fas fa-save mr-2"></i> PAGA AL RETIRAR (GUARDAR)
                            </button>
                        </div>
                        <button className="btn btn-link text-danger mt-3 font-weight-bold" onClick={() => { setModalDecisionRetiro(false); setTipoVenta('USUARIO_PRESENCIAL'); }}>Cancelar</button>
                    </div>
                </div>
            )}

            {/* MENSAJE VISUAL DE VENTA GENERADA */}
            {mostrarExito && (
                <div className="alerta-venta-exitosa">
                    <i className="fas fa-check"></i>
                    <div>
                        <h5 className="m-0 font-weight-bold">¡Venta Generada!</h5>
                        <small>El pedido se ha registrado correctamente</small>
                    </div>
                </div>
            )}

            {/* MODAL AJUSTE DE PROPINA ANTES DE PAGAR */}
            {modalPropinaAbierto && pedidoEnProcesoCobro && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 3000, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(5px)' }}>
                    <div className="bg-white p-4 rounded-4 shadow-lg" style={{ width: '400px', borderRadius: '20px' }}>
                        <h4 className="font-weight-bold mb-2 text-dark">Confirmar Propina</h4>
                        <p className="text-muted small mb-4">{etiquetaPedidoCobro(pedidoEnProcesoCobro)} - Subtotal: ${Number(pedidoEnProcesoCobro.total).toLocaleString('es-CL')}</p>

                        <div className="form-group mb-4">
                            <label className="fw-bold">Monto de Propina ($):</label>
                            <input
                                type="number"
                                className="form-control form-control-lg text-primary fw-bold"
                                value={propinaSeleccionada}
                                onChange={(e) => setPropinaSeleccionada(Number(e.target.value))}
                                autoFocus
                            />
                            <div className="d-flex gap-2 mt-2">
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => setPropinaSeleccionada(0)}>Sin Propina</button>
                                <button className="btn btn-sm btn-outline-info" onClick={() => {
                                    const sub = Number(pedidoEnProcesoCobro.total);
                                    setPropinaSeleccionada(Math.round(sub * 0.10));
                                }}>Sugerir 10%</button>
                            </div>
                        </div>

                        <div className="bg-light p-3 rounded-3 mb-4">
                            <div className="d-flex justify-content-between h5 m-0">
                                <span>Total a Cobrar:</span>
                                <span className="text-primary fw-bold">${(Number(pedidoEnProcesoCobro.total) + propinaSeleccionada).toLocaleString('es-CL')}</span>
                            </div>
                        </div>

                        <div className="d-flex flex-column gap-2">
                            <button className="btn btn-primary btn-lg fw-bold" onClick={() => {
                                setFinalOrder({
                                    ...pedidoEnProcesoCobro,
                                    id_actualizar: pedidoEnProcesoCobro.id,
                                    propina: propinaSeleccionada,
                                    total: Number(pedidoEnProcesoCobro.total) + propinaSeleccionada
                                });
                                setModalPropinaAbierto(false);
                                setModalPagoAbierto(true);
                            }}>
                                PASAR A CAJA <i className="fas fa-chevron-right ms-2"></i>
                            </button>
                            <button className="btn btn-link text-muted" onClick={() => setModalPropinaAbierto(false)}>Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
            {modalCorreccionAbierto && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 3500, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(5px)' }}>
                    <div className="bg-white shadow-lg p-4" style={{ width: '550px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', borderRadius: '25px', border: '1px solid #ddd' }}>

                        {/* CABECERA CON BOTÓN X PARA CERRAR TODO */}
                        <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-3">
                            <div className="d-flex align-items-center">
                                <i className="fas fa-edit text-primary mr-2"></i>
                                <h5 className="font-weight-bold m-0 text-dark">
                                    {pedidoACorregir ? `Corrigiendo: ${pedidoACorregir.mesa_nombre}` : 'Selector de Mesas'}
                                </h5>
                            </div>
                            {/* 🚩 ESTA ES LA "X" QUE TE FALTABA CTM */}
                            <button
                                className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px' }}
                                onClick={() => {
                                    setModalCorreccionAbierto(false);
                                    setPedidoACorregir(null);
                                }}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        {cargandoMesas ? (
                            <div className="text-center p-5"><div className="spinner-border text-primary"></div></div>
                        ) : !pedidoACorregir ? (
                            /* --- VISTA 1: SELECTOR DE MESAS --- */
                            <div className="row g-3 overflow-auto p-2" style={{ flex: 1 }}>
                                {mesasConPedido.length > 0 ? (
                                    mesasConPedido.map(m => (
                                        <div key={m.pedido_id} className="col-6 mb-3">
                                            <div
                                                className="p-3 border rounded-4 text-center hov-light cursor-pointer shadow-sm transition-all"
                                                onClick={() => setPedidoACorregir(m)}
                                            >
                                                <div className="fw-bold">{m.mesa_nombre}</div>
                                                <div className="small text-muted">Folio: #{m.display_id}</div>
                                                <div className="mt-1 fw-bold text-primary">${Number(m.total).toLocaleString('es-CL')}</div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center p-5 text-muted">No hay consumos activos.</div>
                                )}
                            </div>
                        ) : (
                            /* --- VISTA 2: EDICIÓN DE ITEMS --- */
                            <div className="d-flex flex-column" style={{ flex: 1, overflow: 'hidden' }}>
                                <div className="bg-light p-2 rounded-3 mb-3 d-flex justify-content-between align-items-center">
                                    <button className="btn btn-sm btn-link text-primary fw-bold" onClick={() => setPedidoACorregir(null)}>
                                        <i className="fas fa-arrow-left"></i> Volver al selector
                                    </button>
                                </div>

                                <div className="overflow-auto pe-2" style={{ flex: 1 }}>
                                    {pedidoACorregir.items.map((item, idx) => (
                                        <div key={idx} className="p-3 border-bottom d-flex justify-content-between align-items-center">
                                            <div style={{ maxWidth: '65%' }}>
                                                <div className="fw-bold small">{item.cantidad}x {item.nombre}</div>
                                                <div className="text-primary small fw-bold">${Number(item.precio * item.cantidad).toLocaleString('es-CL')}</div>
                                            </div>
                                            <div className="d-flex gap-2">
                                                <button className="btn btn-sm btn-outline-warning" onClick={() => handleCorregirItemMesa(item, item.cantidad - 1)}><i className="fas fa-minus"></i></button>
                                                <button className="btn btn-sm btn-outline-danger" onClick={() => handleCorregirItemMesa(item, 0)}><i className="fas fa-trash-alt"></i></button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* BOTÓN CANCELAR FINAL POR SI EL MOUSE NO LE ACHUNTA A LA X */}
                        {!pedidoACorregir && (
                            <div className="mt-3">
                                <button className="btn btn-light btn-block text-danger fw-bold py-2" onClick={() => setModalCorreccionAbierto(false)}>
                                    CANCELAR / SALIR
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {modalMotivoAbierto && (
                <div className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 3600, top: 0, left: 0, backgroundColor: 'rgba(0,0,0,0.6)' }}>
                    <div className="bg-white shadow-lg p-4" style={{ width: '400px', borderRadius: '20px', border: '1px solid #ddd' }}>
                        <h6 className="font-weight-bold mb-3">¿Motivo de la corrección?</h6>
                        <input
                            type="text"
                            className="form-control mb-3"
                            autoFocus
                            value={motivoTexto}
                            onChange={(e) => setMotivoTexto(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') confirmarCorreccionItemMesa(); }}
                            placeholder="Ej: cliente se arrepintió, error de digitación..."
                        />
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-light"
                                onClick={() => {
                                    setModalMotivoAbierto(false);
                                    setCorreccionPendiente(null);
                                    setMotivoTexto('');
                                }}
                            >
                                Cancelar
                            </button>
                            <button className="btn btn-danger ml-2" onClick={confirmarCorreccionItemMesa}>
                                Confirmar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer position="top-right" autoClose={2500} />
        </div>
    );
}

export default TPV;